import { createFileRoute } from "@tanstack/react-router";

/** `/settings` renders the settings index (both groups as a list) from the layout: the phone entry point (ALP-84 P4). */
export const Route = createFileRoute("/_app/settings/")({
  head: () => ({ meta: [{ title: "Settings · Malfak" }] }),
  component: () => null,
});
